import styled, { css } from "styled-components";

import { Choose } from "../Choose/Choose";

export const StyledChoose = styled(Choose)`
  flex-shrink: 0;
  white-space: nowrap;

  ${(props) =>
    !props.active &&
    css`
      background-color: transparent !important;
    `}
`;

StyledChoose.displayName = "StyledChoose";

export const StyledVerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

StyledVerticalContainer.displayName = "StyledVerticalContainer";

export const StyledRadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  &[data-disabled="true"] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

StyledRadioOption.displayName = "StyledRadioOption";

export const StyledFlexContainer = styled.div`
  display: flex;
  width: 100%;
`;

StyledFlexContainer.displayName = "StyledFlexContainer";
